var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarRental = function SvgCarRental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320-680q-50 0-85-35t-35-85 35-85 85-35q38 0 69 22.5t45 57.5h326v80h-40v80h-80v-80H434q-14 35-45 57.5T320-680m0-80q17 0 28.5-11.5T360-800t-11.5-28.5T320-840t-28.5 11.5T280-800t11.5 28.5T320-760m40 500q17 0 28.5-11.5T400-300t-11.5-28.5T360-340t-28.5 11.5T320-300t11.5 28.5T360-260m240 0q17 0 28.5-11.5T640-300t-11.5-28.5T600-340t-28.5 11.5T560-300t11.5 28.5T600-260M200-376l66-192q5-14 16.5-23t25.5-9h344q14 0 25.5 9t16.5 23l66 192v264q0 14-9 23t-23 9h-16q-14 0-23-9t-9-23v-48H280v48q0 14-9 23t-23 9h-16q-14 0-23-9t-9-23zm106-64h348l-28-80H334zm-26 80v120zm0 120h400v-120H280z"
  })));
};
export default SvgCarRental;